import { CampoAlterado, DadosProfissionalAtribuido } from "./types";
import { parseJsonSafely } from "../../../../../../../utility/jsonUtils";

export const mapearDadosProfissionalAtribuido = (logs: any[]): DadosProfissionalAtribuido | null => {
    const logProposta = logs.find((log: any) => log.entidade_nome === 'proposta');
    
    if (!logProposta) return null;

    const dadosAntes = parseJsonSafely(logProposta.dados_antes);
    const dadosDepois = parseJsonSafely(logProposta.dados_depois);
    const dadosExtra = parseJsonSafely(logProposta.dados_extra);

    const campos: CampoAlterado[] = [];
    const nomeProfissional = dadosExtra?.nome_usuario || undefined;
    const profissionalAnterior = dadosExtra?.profissional_anterior;

    if (dadosDepois && dadosDepois.id_usuario !== undefined) {
        const antes = dadosAntes?.id_usuario || null;
        const depois = dadosDepois.id_usuario;

        let antesTexto: string | null = null;
        if (antes) {
            if (profissionalAnterior && profissionalAnterior.nome) {
                antesTexto = `${profissionalAnterior.nome} (D${antes})`;
            } else {
                antesTexto = `D${antes}`;
            }
        }

        let depoisTexto: string;
        if (nomeProfissional) {
            depoisTexto = `${nomeProfissional} (D${depois})`;
        } else {
            depoisTexto = `D${depois}`;
        }

        campos.push({
            campo: 'Profissional responsável',
            antes: antesTexto,
            depois: depoisTexto
        });
    }

    return {
        campos,
        nomeProfissional
    };
};

